import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { ApiUrlService } from "@app/shared/services/api-url.service";
import { environment } from "@env/environment";
import { catchError, retry } from "rxjs/operators";

import { Logger } from "../logger.service";
import {ToastService} from '../toast.service';
import { HTTP_SKIP_ERROR_HANDLER } from "./http-context";

const log = new Logger("ErrorHandlerInterceptor");

function handleError(request: HttpRequest<any>, error: HttpErrorResponse, toastr: ToastService, apiUrlService: ApiUrlService): never {
  if (
    request.url.includes(apiUrlService.getApiUrl()) ||
    request.url.replace(/\/api\/v\d+/, "").includes(apiUrlService.getApiUrl())
  ) {
    if (error.status === 0) {
      let message = "The api server is not accessible";
      if (!environment.production) {
        message += ". (The webapi server is down)";
      }
      toastr.error(message);
    } else if (error.status === 1001 || error.error?.code?.internalCode === 1001) {
      toastr.error("A validation error occured. Please correct your input");
    } else if (error.status === 500) {
      toastr.error(
        "An error that should not happened has happened. Sorry for that. Please contact the administrator of your company"
      );
    } else if (error.status === 403) {
      toastr.error(
        "Access Denied: You do not have permission to access this resource. Please contact the administrator of your company for assistance."
      );
    } else if (error.status === 401) {
      toastr.error(
        "Unauthorized Access: You must be authenticated to access this resource. Please log in with valid credentials to continue."
      );
    }
  } else {
    toastr.error(
      "An error that should not happened has happened. Sorry for that. Please contact the administrator"
    );
  }

  if (!environment.production) {
    log.error("Request error", error);
  }
  throw error;
}

export const errorHandlerInterceptorFn: HttpInterceptorFn = (request, next) => {
  if (request.context.get(HTTP_SKIP_ERROR_HANDLER)) {
    return next(request);
  }

  const toastr = inject(ToastService);
  const apiUrlService = inject(ApiUrlService);
  return next(request).pipe(
    retry(0),
    catchError((error: HttpErrorResponse) => handleError(request, error, toastr, apiUrlService)),
  );
};
